/** Checkbox keys sent to purgeSchoolCompletely — keep aligned with functions/schoolPurge.js */

export const SCHOOL_PURGE_SECTIONS = [
  {
    id: "registry",
    title: "Registry & portal",
    items: [
      { key: "schoolRecord", label: "School registry record", hint: "schools/{id} — profile, answers, workflow, portal access" },
      { key: "lifecycle", label: "Lifecycle & email history", hint: "schools/{id}/lifecycle/*" },
    ],
  },
  {
    id: "workflow",
    title: "Accreditation workflow data",
    items: [
      { key: "audit", label: "SEF / audit workspace", hint: "audits/{id}" },
      { key: "liveReport", label: "Live report (current cycle)", hint: "reports/{id} and staff workspace" },
      { key: "reportArchives", label: "Issued report archives", hint: "schools/{id}/reports_archive/*" },
      { key: "questionnaireRaw", label: "Questionnaire (raw)", hint: "questionnaires_raw/{id}" },
      { key: "distilledData", label: "Refinery / distilled evidence", hint: "distilledData/{id}" },
    ],
  },
  {
    id: "storage",
    title: "Files in Storage",
    items: [
      { key: "evidenceFiles", label: "Evidence vault files", hint: "evidence/{id}/*" },
      { key: "portalLogo", label: "Portal / public logo", hint: "schoolBranding/{id}/*" },
      { key: "generatedPdfs", label: "Generated PDF exports", hint: "generated_reports/* and generated_certificates/* for this school" },
    ],
  },
  {
    id: "public",
    title: "Public & external visibility",
    items: [
      { key: "publicBadge", label: "Public badge & verify page", hint: "publicBadges/{publicBadgeId}" },
      { key: "accreditedShowcase", label: "Corporate accredited schools list", hint: "public/schoolShowcase.accreditedSchools[]" },
      { key: "flagshipShowcase", label: "Flagship Schools carousel", hint: "When curated id matches this school", flagshipOnly: true },
    ],
  },
  {
    id: "translations",
    title: "Translations",
    items: [
      { key: "reportTranslations", label: "Translated report strings", hint: "v2_report_masters / v2_report_translations" },
    ],
  },
  {
    id: "analytics",
    title: "Analytics & admin clutter",
    items: [
      { key: "globalBenchmarks", label: "Global benchmarking snapshot", hint: "globalBenchmarks/{id}" },
      { key: "benchmarkCounter", label: "Adjust benchmarking sample counter", hint: "settings/benchmarking.publishedReportsCount" },
      { key: "staffNotifications", label: "Staff notifications for this school", hint: "notifications/* with matching linkId" },
    ],
  },
];

export const ALL_PURGE_TARGET_KEYS = SCHOOL_PURGE_SECTIONS.flatMap((s) => s.items.map((i) => i.key));

export function emptyPurgeTargets() {
  return ALL_PURGE_TARGET_KEYS.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
}

export function sectionTargetKeys(section) {
  return section.items.map((i) => i.key);
}
